<template>
  <UploadForm class="form-wrap" v-if="!$store.state.env.isMobile"></UploadForm>
  <UploadFormMobile v-else></UploadFormMobile>
</template>
<script>
import UploadForm from "@/components/upload/UploadForm.vue";
import UploadFormMobile from "@/components/upload/UploadFormMobile.vue";
export default {
  name: "Upload",
  components: {
    UploadForm,
    UploadFormMobile
  },
};
</script>
<style lang="scss" scoped>
// .form-wrap {
//   width: 470px;
//   margin: 0 auto;
//   padding-bottom: 80px;
// }
</style>